

import Vue from "vue";
import { CrmSheduleCalendarOptions } from "@/utils/crm/crm-shedule-calendar-options";
import Crm from "@/models/crm/crm";
import VueI18n from "vue-i18n";
import AppCrmStatus from "./CrmStatus.vue";
import AppCrmSelectAssigned from "./CrmSelectAssigned.vue";
import AppCrmShedule from "./CrmShedule.vue";
import { printLocalDateTime } from "@/utils/pretty-print";

export default Vue.extend({
	data() {
		return {
			sheduleCrm: false
		};
	},
	props: {
		crm: {
			required: true,
			type: Object as () => Crm
		},
	},
	computed: {
		priorities(): any[] {
			return Object.entries(this.$ct("priorities") as any as VueI18n.TranslateResult[]).map(s => {
				return {
					text: s[1],
					value: parseInt(s[0])
				};
			});
		},
		sheduledTime(): string{
			return this.crm.TimeSheduled ? printLocalDateTime(this.crm.TimeSheduled) : "";
		}
	},
	methods: {
		save(options?:CrmSheduleCalendarOptions){
			this.$emit("save", options);
		}
	},
	components: {
		AppCrmStatus,
		AppCrmSelectAssigned,
		AppCrmShedule
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
	